import { useEffect, useState, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useTeamRole } from "@/hooks/useTeamRole";

export interface TeamMember {
  id: string;
  owner_name: string | null;
  agency_email: string | null;
  team_role: "owner" | "manager" | "staff";
  last_login: string | null;
  invite_accepted: boolean;
}

export function useTeamMembers() {
  const { agencyId } = useTeamRole();
  const [members, setMembers] = useState<TeamMember[]>([]);
  const [loading, setLoading] = useState(true);

  const fetch = useCallback(async () => {
    if (!agencyId) { setMembers([]); setLoading(false); return; }
    const { data } = await supabase
      .from("profiles")
      .select("id, owner_name, agency_email, team_role, last_login, invite_accepted")
      .eq("agency_id", agencyId);
    setMembers((data ?? []) as TeamMember[]);
    setLoading(false);
  }, [agencyId]);

  useEffect(() => { fetch(); }, [fetch]);

  return { members, loading, refetch: fetch };
}
